export const ufiEmergenciasConfig = [
  {
    path: "/actuaciones/new/ufi-emergencias-medicas/initial",
    pathName: "ufi-emergencias-medicas",
    titulo: "UFI - EMERGENCIAS MÉDICAS",
    props: { formType: "ufi-emergencias-medicas", actuacionType: "ufi-emergencias-medicas" },
    nameOfRoute: "actuacion-initial",
  },
  {
    path: "/actuaciones/new/ufi-emergencias-medicas/initial/denunciante",
    pathName: "ufi-emergencias-medicas",
    titulo: "AFECTADOS",
    nameOfRoute: "actuacion-form-denunciante",
  },
  {
    path: "/actuaciones/new/ufi-emergencias-medicas/initial/momento",
    pathName: "ufi-emergencias-medicas",
    titulo: "FECHA, HORA y UBICACIÓN",
    nameOfRoute: "actuacion-form-momento",
  },
  {
    path: "/actuaciones/new/ufi-emergencias-medicas/initial/efectos",
    pathName: "ufi-emergencias-medicas",
    titulo: "EFECTOS",
    nameOfRoute: "actuacion-form-efectos",
  },
];
